import React from 'react';
import ListContainer from '../../Componant/UiKits/Lists';

const List = () => {
  return (
    <div className='page-body default-list-border'>
      <ListContainer />
    </div>
  );
};

export default List;
